import {
  type LegalContentConfig,
  type LegalSlug,
  PrivacyPolicyMDX,
  ReturnsRefundsMDX,
  ShippingMDX,
  TermsConditionsMDX,
} from '@boc/legal';

import { brandInfo } from '#/brand';
import { channels } from '#/channels';

function buildLegalConfig(channelSlug: string): LegalContentConfig {
  const channel = channels[channelSlug];
  const entity = channel?.entity;
  const phone = channel?.urlSlug === 'in' ? brandInfo.phone.india : brandInfo.phone.uae;
  return {
    domain: 'jigsawnation.com',
    contactEmail: brandInfo.emails.contact,
    contactPhone: phone,
    legalEntity: entity?.legalEntity ?? 'Band of Capes Pvt. Ltd.',
    companyName: brandInfo.name,
    address: entity?.store?.address,
  };
}

export function getContent(channelSlug: string): Record<LegalSlug, JSX.Element> {
  const config = buildLegalConfig(channelSlug);
  return {
    returns: <ReturnsRefundsMDX config={config} />,
    terms: <TermsConditionsMDX config={config} />,
    privacy: <PrivacyPolicyMDX config={config} />,
    shipping: <ShippingMDX config={config} />,
  };
}

// Static fallback for backwards compatibility (uses India defaults)
export const content: Record<string, JSX.Element> = getContent('in');
